import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export default function ThemeSwitcher() {
  const { mode, setMode } = useTheme();
  const options = [
    { key: "light", icon: Sun, label: "Clair" },
    { key: "dark", icon: Moon, label: "Sombre" },
    { key: "system", icon: Monitor, label: "Système" },
  ];
  return (
    <div className="inline-flex items-center gap-1 p-1 rounded-xl bg-[#F3F1EC] dark:bg-[#252320] border border-[#E8E6E1] dark:border-[#2E2C29]" data-testid="theme-switcher">
      {options.map(o => {
        const Icon = o.icon;
        const active = mode === o.key;
        return (
          <button
            key={o.key}
            type="button"
            data-testid={`theme-${o.key}`}
            onClick={() => setMode(o.key)}
            className={`inline-flex items-center gap-1.5 px-3 h-9 rounded-lg text-xs font-semibold transition ${
              active ? "bg-white dark:bg-[#1A1918] text-[#1A1918] dark:text-[#F5F3EE] shadow-sm" : "text-[#73706B]"
            }`}
          >
            <Icon className="h-3.5 w-3.5" />
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
